import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '../../../../../../services/login/login.service';
import { SwalService } from '../../../../../../services/swal/swal.service';
import { DataAddress } from '../../../../../../views/clientes/model/DataAddress';
import { Observable, throwError } from 'rxjs';
import { Respuesta } from '../models/Response';
import { DataUser } from '../../../../../../models/generar_pedido/DataUser';
import { environment } from '../../../../../../../environments/environment';
import { catchError, map, retry } from 'rxjs/operators';
import { EmpresaService } from '../../../../../../services/Empresa/Empresa.service';


@Injectable({
  providedIn: 'root'
})
export class AddressService {
  empresaId: string;

  constructor(
    private http: HttpClient,
    private login: LoginService,
    private swal: SwalService,
    private empresaService: EmpresaService
  ) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  public addAddress = (data: DataAddress): Observable<Respuesta> => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const dataQuery = {
      client_id: dataUser.client_number,
      empresa_id: this.empresaId,
      data,
      esPublicogeneral: dataUser.es_publicogeneral,
      correo: dataUser.email,
    };
    // const url = dataUser.es_publicogeneral === 'SI' ? 'account-test' : 'account';
    return this.http.post<Respuesta>(environment.apiUrl + '/account-test/addresses/set_address_new_delivery.php', dataQuery)
      .pipe(
        retry(3),
        catchError(this.handleError),
        map(response => {
          return response;
        }));
  }

  public updateAddress = (data: DataAddress, id: number): Observable<Respuesta> => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const datosQuery = {
      direccion_id: id,
      client_id: dataUser.client_number,
      empresa_id: this.empresaId,
      data,
      esPublicogeneral: dataUser.es_publicogeneral,
      correo: dataUser.email,
    };
    return this.http.post<Respuesta>(environment.apiUrl + 'account-test/addresses/update_address_new_delivery.php', datosQuery)
      .pipe(
        retry(3),
        catchError(this.handleError),
        map(response => response));
  }

  public getCPApi = (cp) => {
    const dataQuery = {
      codigopostal: cp,
      option: 'getCodigoPostal'
    };
    return this.http.post<any>('https://api.integradora.net/account/addresses/getCodigoPostal.php', dataQuery)
      .pipe(
        catchError(this.handleError),
        map(response => {
          return response;
        })
      );

  }

  private handleError = (error: HttpErrorResponse | any) => {
    const cliente = this.login.getDataClientePedido();
    this.swal.swalError(
      'Añadir dirección',
      'Lo sentimos, ocurrio un error de comunicación.<br/><br/>Error: ' + error.message +
      '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
    return throwError(error);
  }
}
